import { resetAccessorial } from "../../features/accessorial/accessorialDetailSlice";
import { resetCwtRateCard } from "../../features/cwtRateCard/cwtRateCardSlice";
import { resetFuelCost } from "../../features/FuelCost/FuelCostSlice";
import { resetService } from "../../features/service/serviceDetailSlice";
import { resetVehicle } from "../../features/vehicle/vehicleDetailSlice";

export const resetAllSlices = () => (dispatch) => {
    dispatch(resetVehicle());
    dispatch(resetService());
    dispatch(resetAccessorial());
    dispatch(resetCwtRateCard());
    dispatch(resetFuelCost());
};